import { render, staticRenderFns } from "./SabbaticalAdjustmentList.vue?vue&type=template&id=0965561b&scoped=true&"
import script from "./SabbaticalAdjustmentList.vue?vue&type=script&lang=js&"
export * from "./SabbaticalAdjustmentList.vue?vue&type=script&lang=js&"
import style0 from "./SabbaticalAdjustmentList.vue?vue&type=style&index=0&id=0965561b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0965561b",
  null
  
)

export default component.exports